import helpers from '@/store/helpers'
import Promise from 'promise-polyfill'

const Employee = {
  namespaced: true,
  state: {
    items: null
  },
  mutations: {
    load (state, payload) {
      const data = payload.map(x => { return {...x, displayName: x.name + ' (' + x.nik + ')'} })
      state.items = Object.assign([], data)
    },
    reset (state, payload) {
      state.items = null
    }
  },
  actions: {
    refresh: (context, payload) => helpers.refresh(context, payload,
      {backend: 'employee', method: 'getEmployeeAuthUsingGET', mutation: 'load', state: 'items'}),
    list: (context, payload) => helpers.list(context, payload, {action: 'refresh', state: 'items'}),
    reset: (context, payload) => context.commit('reset'),
    get: (context, payload) => {
      if (context.state.items === null) {
        return new Promise((resolve, reject) => {
          context.dispatch('list', {vueinstance: payload.vueinstance})
            .then(res => {
              const employee = res.filter(x => x.empId === payload.empId)
              if (employee.length === 0) {
                reject(new Error('Employee not found'))
              } else {
                resolve(employee[0])
              }
            })
            .catch(err => {
              reject(err)
            })
        })
      } else {
        return new Promise((resolve, reject) => {
          const employee = context.state.items.filter(x => x.empId === payload.empId)
          if (employee.length === 0) {
            reject(new Error('Employee not found'))
          } else {
            resolve(employee[0])
          }
        })
      }
    },
    searchEmployee: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.employee.getEmployeeAllUsingGET({key: payload.key})
          .then(res => resolve(res.body))
          .catch(err => reject(err))
      })
    }
  }
}

export default Employee



// WEBPACK FOOTER //
// ./src/store/master/Employee.js